// Maps a Supabase shift row (snake_case) to the shape the calendar + components expect.
export function mapShiftRow(row) {
  return {
    docID: row.id,
    client: row.client,
    caretaker: row.caretaker,
    start: row.start_time,
    end: row.end_time,
    title: row.client + ' - ' + row.caretaker,
    comments: row.comments,
    color: row.color,
    editedStartTime: row.edited_start_time,
    editedEndTime: row.edited_end_time,
    prettyEditedStartTime: row.pretty_edited_start_time,
    prettyEditedEndTime: row.pretty_edited_end_time,
    caretakerEmail: row.caretaker_email,
    repeatingShift: row.repeating_shift,
    repeatingShiftID: row.repeating_shift_id,
    startTimeSecs: row.start_time_secs,
    originalStartTime: row.original_start_time,
    originalEndTime: row.original_end_time,
    isFlatFee: row.is_flat_fee,
    flatFeeAmount: row.flat_fee_amount,
    flatFeeAmountClient: row.flat_fee_amount_client,
    shiftMileage: Number(row.shift_mileage)
  };
}
